import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_TIMELINESS_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_TIMELINESS_SUMMARY.id,
    requestParams: {
      // eslint-disable-next-line no-nested-ternary
      operatorFrom: rowInfo.row['sender'] ? (rowInfo.row['sender'].length === 3 ? rowInfo.row['sender'] : rowInfo.row['sender'].substring(3, 6)) : '',
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('All', 'receptacles.all'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Air', 'receptacles.air'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Road', 'receptacles.road'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Sea', 'receptacles.sea'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Rail', 'receptacles.rail'), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Receptacles not measured',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('All', 'receptaclesNotMeasured.all'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Air', 'receptaclesNotMeasured.air'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Road', 'receptaclesNotMeasured.road'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Sea', 'receptaclesNotMeasured.sea'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Rail', 'receptaclesNotMeasured.rail'), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Measured receptacles on time',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('All', 'receptaclesMeasuredOnTime.all'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Air', 'receptaclesMeasuredOnTime.air'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Road', 'receptaclesMeasuredOnTime.road'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Sea', 'receptaclesMeasuredOnTime.sea'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('Rail', 'receptaclesMeasuredOnTime.rail'), getDetailsTabNavOptions),
      ],
    },
    {
      Header: '% Measured receptacles on time',
      columns: [
        new NonZeroPercentageColumn('All', 'receptaclesMeasuredPct.all'),
        new NonZeroPercentageColumn('Air', 'receptaclesMeasuredPct.air'),
        new NonZeroPercentageColumn('Road', 'receptaclesMeasuredPct.road'),
        new NonZeroPercentageColumn('Sea', 'receptaclesMeasuredPct.sea'),
        new NonZeroPercentageColumn('Rail', 'receptaclesMeasuredPct.rail'),
      ],
    },
  ];
};
